<button
  data-cy="reportOptionsMenuButton"
  class="flex h-9 w-9 items-center justify-center rounded focus:outline-none"
  [ngClass]="{
    'hover:bg-m0': isHoverM === true,
    'hover:bg-m200': isHoverM === false
  }"
  #t1="tippy"
  [tp]="templateReportOptions"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  className="my-menu"
  [tpOffset]="[0, 4]"
  (click)="clickMenu($event)"
>
  <m-dots-vertical-icon></m-dots-vertical-icon>
</button>

<ng-template #templateReportOptions>
  <div class="border-s4 bg-m0 w-64 rounded-md border-2 shadow-xl">
    <button
      data-cy="reportOptionsGoToFileButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); goToFile($event)"
      >Go to File</button
    >

    <div
      tp="Admin or Editor role required"
      placement="left"
      [tpIsEnabled]="currentReportUnit.canEditOrDeleteReport === false"
    >
      <button
        data-cy="reportOptionsEditInfo"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            currentReportUnit.canEditOrDeleteReport === false
        }"
        (click)="t1.hide(); editReportInfo($event)"
        [disabled]="currentReportUnit.canEditOrDeleteReport === false"
        >Edit Info</button
      >
    </div>

    <div
      tp="Admin or Editor role required"
      placement="left"
      [tpIsEnabled]="currentReportUnit.canEditOrDeleteReport === false"
    >
      <button
        data-cy="reportOptionsDelete"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            currentReportUnit.canEditOrDeleteReport === false
        }"
        (click)="t1.hide(); deleteReport($event)"
        [disabled]="currentReportUnit.canEditOrDeleteReport === false"
        >Delete</button
      >
    </div>
  </div>
</ng-template>
